import React from 'react';
import { useTranslation } from 'react-i18next';
import { HtmlTrans, SectionHeader, Typography } from 'web-library';
import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) =>
({
  a: {
    textDecoration: 'none',
    color: theme.color.link.linkDefault01,
  },
}));

const PsleInstruction = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader title="Important" />
      <Typography variant="h3">
        {t('amendment->>GroupSubjectAmendmentRegister.BeforeYouBegin')}
      </Typography>
      <ol>
        <li>
          <Typography variant="body1">
            {t('amendment->>GroupSubjectAmendmentRegister.YouNeedFollowingInformation')}
          </Typography>
          <ol type="a">
            <li>
              <Typography variant="body1">
                {t('amendment->>GroupSubjectAmendmentRegister.CandidatePersonalParticulars')}
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                {t('amendment->>GroupSubjectAmendmentRegister.SubjectsPapersRegistered')}
              </Typography>
            </li>
          </ol>
          <li>
            <Typography variant="body1">
              {t('amendment->>GroupSubjectAmendmentRegister.ALLFieldsAreMandatory')}
            </Typography>
          </li>
        </li>
      </ol>
      <Typography variant="body1">
        <HtmlTrans
          i18nKey="amendment->>GroupSubjectAmendmentRegister.ForMoreInformation"
          values={{
            aClass: classes.a,
          }}
        />
      </Typography>
    </>
  );
};
export default PsleInstruction;
